import { render, staticRenderFns } from "./LogoutWarningDialog.vue?vue&type=template&id=aa538a7a&"
import script from "./LogoutWarningDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports